var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('../../src/js/vendor/slick.js');
//require('slick-carousel');

/**
 * Initializes the hero module.
 * @constructor
 * @param {Object} el - The hero element.
 */
 function Quotes(el) {
  this.el = el;
 	this.$el = $(el);

	$('.js-quotes').slick({
		dots: true,
		infinite: true,
		speed: 600,
		autoplay: true,
		autoplaySpeed: 6000,
		fade: true,
		accessibility: false,
		arrows: false
	}).on('afterChange', function () {
		var currentDot = $('.slick-dots li[aria-current="true"]');
		$('.slick-dots li button').removeAttr('aria-current');
		if (currentDot) {
			$('button', currentDot).attr('aria-current', 'true');
		}
		$('.slick-dots li').removeAttr('aria-hidden aria-current');
	});

	$('.slick-dots li[aria-current="true"] button').attr('aria-current', 'true');

	setTimeout(function () {
		$('.slick-list').removeAttr('aria-live');
		$('.slick-dots li').removeAttr('aria-hidden');
		$('.slick-dots button').text('').removeAttr('role').removeAttr('tabindex').keypress(function () {
			$('.slick-dots button').removeAttr('aria-selected');
		});
		$('.quotes__controller').click(function () {
			if ($(this).hasClass('playing')) {
				$('.js-quotes').slick('slickPause');
				$('.slick-list').attr('aria-live', 'polite');
			} else {
				$('.js-quotes').slick('slickPlay');
				$('.slick-list').removeAttr('aria-live');
			}
			$(this).toggleClass('playing');
		});
	}, 200);
}

module.exports = Quotes;
